/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
import { Button, Heading, Link, Text, Typography } from '@zapier/design-system';

import Surface from '../../shared/Surface';

type UpgradeProps = {
  /** Called when the user clicks the "Upgrade" button. */
  onClickUpgrade: () => void;
  /** The URL of the "View Plans & Pricing" link. */
  viewPlansUrl: string;
};

const Styles = {
  title: {
    ...Typography.SectionHeader,
    margin: '15px 0 10px',
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 20,
  },
  viewPlansLink: {
    ...Typography.Body4,
    margin: '0 0 0 18px',
    border: `none`,
    background: `none`,
  },
};

/**
  This page of the contact form is displayed when the user exits the
  upgrade prompt without upgrading their account or starting a trial.
*/
const Upgrade = ({ onClickUpgrade, viewPlansUrl }: UpgradeProps) => (
  <Surface>
    <Heading css={Styles.title}>Join a paid plan for access to Support</Heading>
    <Text tag="p" type="Body1">
      To message our world-class Support team, upgrade your account. You may be
      eligible for a free trial, no credit-card required.
    </Text>
    <div css={Styles.buttons}>
      <Button onClick={onClickUpgrade}>Upgrade</Button>
      <span css={Styles.viewPlansLink}>
        <Link href={viewPlansUrl} target="_blank">
          View plans &amp; pricing
        </Link>
      </span>
    </div>
  </Surface>
);

export default Upgrade;
